import React, {useEffect, useRef} from 'react';
import classNames from 'classnames';
import {Toast} from '@store/toast/Toast.types';
import ToastActions from '@store/toast/ToastActions';
import './ToastDisplay.sass';
import {XMarkLargeIcon} from '@components/icon/XMarkLargeIcon';
import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

interface ToastDisplayProps {
  toast: Toast;
}

export default function ToastDisplay({toast}: ToastDisplayProps) {
  const toastRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Don't timeout dismissable toasts
    if (toast.dismissible) return;

    // After time fade out
    setTimeout(() => {
      toastRef.current?.classList.add('fadeout');
    }, toast.time);

    // After time + animation buffer remove from store
    setTimeout(() => {
      ToastActions.removeToast(toast);
    }, toast.time + 3000);
  }, [toast]);

  return (
    <div
      onClick={e => {
        if (toast.onClick) {
          toast.onClick();
        }
        ToastActions.removeToast(toast);
      }}
      className={classNames('toast', 'animated', 'bounceIn', toast.type, {
        dismissible: toast.dismissible,
        clickable: !!toast.onClick,
      })}
      ref={toastRef}>
      {toast.dismissible && (
        <CloseButton
          onClick={e => {
            ToastActions.removeToast(toast);
            e.stopPropagation();
          }}>
          <XMarkLargeIcon height={14} tooltip="Close" />
        </CloseButton>
      )}
      {toast.message}
    </div>
  );
}

const CloseButton = withStyles(theme => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}))(IconButton);
